import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { AppProviders } from "./App";
import "./styles.css";

const host = document.getElementById("root");
if (!host) {
  throw new Error("Der Einhängepunkt #root fehlt in index.html");
}

createRoot(host).render(
  <StrictMode>
    <AppProviders />
  </StrictMode>,
);
